import { render, staticRenderFns } from "./DITLifecycle.vue?vue&type=template&id=17d8e866&scoped=true&"
import script from "./DITLifecycle.vue?vue&type=script&lang=js&"
export * from "./DITLifecycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d8e866",
  null
  
)

export default component.exports